import _ from 'underscore';
import { odataErrorCodes } from '@bingads-webui-campaign/instrumentation';

import { getErrorString } from '../logger/index';

// get date string with offset, such as: '2022-01-01+08:00'
export const formatCivilDate = (i18n, civilDate, timeZone, utcOffset, timeStr) => {
  const rawFormat = timeStr ? `yyyy-MM-ddT${timeStr}` : 'yyyy-MM-dd';
  const dateStr = i18n.formatCivilDate(civilDate, { raw: rawFormat, timeZone });
  // encode '+' char
  const offset = utcOffset ? utcOffset.replace('+', '%2B') : '';
  return `${dateStr}${offset}`;
};

export const isErrorWhitelisted = (error = {}) => {
  if (error.errors && error.errors.length === 1) {
    const errorCode = error.errors[0].Code;

    if (_.isString(errorCode)) {
      return _.contains(odataErrorCodes, errorCode.toUpperCase());
    }
  }
  return false;
};

export const handleErrorLogging = (err, api, logger) => {
  if (isErrorWhitelisted(err)) {
    logger.logTrace(`[IgnoredDataServiceError] ${getErrorString(err)}`, { api });
  } else {
    logger.logError(err, null, api);
  }
};

// eslint-disable-next-line no-unused-vars
export const removeNullUndefined = (obj) => {
  const newObj = {};
  _.keys(obj).forEach((key) => {
    if (_.isObject(obj[key])) {
      newObj[key] = removeNullUndefined(obj[key]);
    } else if (obj[key] !== null && obj[key] !== undefined) {
      newObj[key] = obj[key];
    }
  });
  return newObj;
};
